// Строка на «Обзоре» «Себестоимости»: на складах есть минусы (и позиции без цены) — себестоимость может быть посчитана
// неверно; ссылка на вкладку «Склад». Данные — сводка последнего снимка остатков (/data/stock/summary, без запросов
// в iiko): её считают вкладка «Склад» и ежедневный воркер. Нет сводки или минусов — строки нет. От периода не зависит.
// Ресторан — как на «Складе»: у сети выбранный ресторан, у одного ресторана — все организации.
import React, { useEffect, useState } from 'react';
import { Box, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { fetchStockSummary } from '../../../services/dataService';
import { CARD_SURFACE_SX, SECTION_ACCENTS } from '../../../styles/tokens';
import { isChain, kitchenFilter } from '../../../utils/restaurant';
import { overviewLine } from '../utils/stockModel';

const ACCENT = SECTION_ACCENTS['/cost'];
const WARNING_COLOR = '#f0a43a';

export default function StockAlert({ selectedGroup, allGroups }) {
  const [summary, setSummary] = useState(null);
  const token = localStorage.getItem('token');
  const restaurant = kitchenFilter(selectedGroup, isChain(allGroups)).restaurant || null;

  useEffect(() => {
    if (!token) return undefined;
    let alive = true;
    setSummary(null);
    fetchStockSummary(token, restaurant)
      .then((data) => alive && setSummary(data))
      .catch(() => alive && setSummary(null));
    return () => {
      alive = false;
    };
  }, [token, restaurant]);

  const text = overviewLine(summary);
  if (!text) return null;
  return (
    <Box
      role="status"
      sx={{ ...CARD_SURFACE_SX, width: '100%', boxSizing: 'border-box', px: 2, py: 1.25, display: 'flex', alignItems: 'center', gap: 1.25 }}
    >
      <WarningAmberRoundedIcon aria-hidden="true" sx={{ flexShrink: 0, fontSize: 20, color: WARNING_COLOR }} />
      <Typography sx={{ flex: 1, minWidth: 0, fontSize: '14px', color: '#e4e4e7' }}>{text}</Typography>
      <Link
        component={RouterLink}
        to="/cost?tab=stock"
        underline="hover"
        sx={{ flexShrink: 0, fontSize: '14px', fontWeight: 600, color: ACCENT.tab, whiteSpace: 'nowrap' }}
      >
        Склад →
      </Link>
    </Box>
  );
}
